import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-help-hms',
    templateUrl: './help-hms.component.html',
    styleUrl: './help-hms.component.css',
    standalone: false
})
export class HelpHmsComponent {

  // images
    @Input() getImgs: string[] = [];
    @Output() showImg: EventEmitter<string> = new EventEmitter<string>();
  
    constructor() {
  
    }
  
    ngOnInit(): void {
  
    }
  
    // show selected image on screen
    showImage(url: string): void {
      this.showImg.emit(url);
    }
}
